const documentDefinitions = [
    // Image formats
    { contentType: 'image/jpeg', extension: 'jpeg' },
    { contentType: 'image/jpeg', extension: 'jpg' },
    { contentType: 'image/png', extension: 'png' },
    { contentType: 'image/gif', extension: 'gif' },
    { contentType: 'image/bmp', extension: 'bmp' },
    { contentType: 'image/webp', extension: 'webp' },
    { contentType: 'image/svg+xml', extension: 'svg' },
    { contentType: 'image/x-icon', extension: 'ico' },
    { contentType: 'image/tiff', extension: 'tiff' },
    { contentType: 'image/tiff', extension: 'tif' },
    { contentType: 'image/heic', extension: 'heic' },
    { contentType: 'image/heif', extension: 'heif' },
    { contentType: 'image/avif', extension: 'avif' },
    { contentType: 'image/jxl', extension: 'jxl' },

    // Video formats
    { contentType: 'video/mp4', extension: 'mp4' },
    { contentType: 'video/quicktime', extension: 'mov' },
    { contentType: 'video/x-msvideo', extension: 'avi' },
    { contentType: 'video/x-ms-wmv', extension: 'wmv' },
    { contentType: 'video/x-flv', extension: 'flv' },
    { contentType: 'video/webm', extension: 'webm' },
    { contentType: 'video/x-m4v', extension: 'm4v' },
    { contentType: 'video/3gpp', extension: '3gp' },
    { contentType: 'video/x-matroska', extension: 'mkv' },
    { contentType: 'video/ogg', extension: 'ogv' },
    { contentType: 'video/mp2t', extension: 'ts' },
    { contentType: 'video/mp2t', extension: 'mts' },
    { contentType: 'video/mp2t', extension: 'm2ts' },
    { contentType: 'video/x-f4v', extension: 'f4v' },
    { contentType: 'video/x-ms-asf', extension: 'asf' },
    { contentType: 'application/vnd.rn-realmedia', extension: 'rm' },
    { contentType: 'application/vnd.rn-realmedia-vbr', extension: 'rmvb' },
    { contentType: 'video/mpeg', extension: 'vob' },
    { contentType: 'application/ogg', extension: 'ogx' },

    // Audio formats
    { contentType: 'audio/mpeg', extension: 'mp3' },
    { contentType: 'audio/wav', extension: 'wav' },
    { contentType: 'audio/aac', extension: 'aac' },
    { contentType: 'audio/ogg', extension: 'ogg' },
    { contentType: 'audio/flac', extension: 'flac' },
    { contentType: 'audio/mp4', extension: 'm4a' },
    { contentType: 'audio/x-ms-wma', extension: 'wma' },
    { contentType: 'audio/opus', extension: 'opus' },

    // Document formats
    { contentType: 'application/pdf', extension: 'pdf' },
    { contentType: 'application/msword', extension: 'doc' },
    { contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', extension: 'docx' },
    { contentType: 'application/vnd.ms-excel', extension: 'xls' },
    { contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', extension: 'xlsx' },
    { contentType: 'text/csv', extension: 'csv' },
    { contentType: 'application/vnd.ms-powerpoint', extension: 'ppt' },
    { contentType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', extension: 'pptx' },
    { contentType: 'text/plain', extension: 'txt' },
    { contentType: 'application/json', extension: 'json' },
];

class PropertyDocumentUtil {
    static validContentTypes = documentDefinitions.map((definition) => definition.contentType);

    static isValidContentType(contentType: string): boolean {
        return PropertyDocumentUtil.validContentTypes.includes(contentType);
    }

    static isValidFileName(fileName: string): boolean {
        if (/[\\\\/:`~*?"<>|#%]/.test(fileName)) {
            return false;
        }
        return true;
    }

    static isValid(fileName: string, contentType: string): boolean {
        const extension = fileName.split('.').pop();
        // eslint-disable-next-line max-len
        const definition = documentDefinitions.find((def) => def.extension.toLowerCase() === extension?.toLowerCase());

        if (definition === undefined) return false;

        return definition.contentType === contentType;
    }

    static rename(originalFileName: string, newFileNameNoExtension: string): string | null {
        const extension = originalFileName.split('.').pop();
        const definition = documentDefinitions.find((def) => def.extension === extension);

        if (definition === undefined) return null;

        return `${newFileNameNoExtension}.${extension}`;
    }
}

export {
    PropertyDocumentUtil,
};
